<template>
  <div>
    <b-row>
      <b-col>
        <label class="mt-2 font-weight-bold"
               for="grade">Grade<span
          class="grey--text">  0 (bad) - 10 (great)</span></label>
        <b-form-input id="grade"
                      v-model="proposalFromValue.proposal.review.grade"
                      :readonly="disabled"
                      max="10"
                      min="0"
                      step="0.5"
                      type="number"
                      @paste.prevent/>
      </b-col>
      <b-col>
        <label class="mt-2 font-weight-bold">Suggested number of shifts</label>
        <b-input-group v-for="shift in shifts_config"
                       :key="shift.model"
                       :append="shift.type"
                       :class="shift.class">
          <span v-if=isNumberOfShiftsOutOfRange(shift)
                class="custom-text-danger">
            The number of shifts must be in range {{ shift.min }} - {{ shift.max }}
          </span>
          <b-form-input v-model="proposalFromValue.proposal.review[shift.model]"
                        :max="shift.max"
                        :min="shift.min"
                        :readonly="shift.readonly || disabled"
                        :step="shift.step"
                        placeholder="Number of shifts"
                        type="number"
                        @paste.prevent/>
        </b-input-group>
      </b-col>
    </b-row>

    <b-form-group label="Confidential comment for the Panel (visible for PRC and Solaris management)"
                  label-class="mt-2 font-weight-bold"
                  label-for="comment">
      <b-form-textarea id="comment"
                       v-model="proposalFromValue.proposal.review.comments"
                       :readonly="disabled"
                       rows="3"/>
    </b-form-group>

    <b-button class="ma-1 right"
              variant="info"
              @click="save_review">
      SAVE
    </b-button>

  </div>
</template>

<script>
  import { infrastructureMixin } from '@/mixins/infrastructure';
  import _ from 'lodash';

  export default {
    name: 'review_form',
    mixins: [infrastructureMixin],
    props: {
      shifts_config: {
        type: Array,
        default: () => [],
      },
      value: {
        type: Object,
        required: true,
      },
    },
    data() {
      return { proposalFromValue: JSON.parse(JSON.stringify(this.value)) };
    },
    computed: {
      disabled() {
        return this.proposalFromValue.proposal.review.states.name !== 'draft';
      },
    },
    watch: {
      value: {
        handler() {
          this.proposalFromValue = JSON.parse(JSON.stringify(this.value));
        },
        deep: true,
      },
    },
    methods: {
      isNumberOfShiftsOutOfRange(shift) {
        if (this.proposalFromValue.proposal.review[shift.model] === undefined) return false;
        return !_.inRange(this.proposalFromValue.proposal.review[shift.model], shift.min, Number(shift.max) + 1);
      },
      isAnyNumberOfShiftsOutOfRange() {
        const anyShiftOutOfRange = this.shifts_config.map((shift) => this.isNumberOfShiftsOutOfRange(shift));
        return anyShiftOutOfRange.some((outOfRange) => outOfRange === true);
      },
      save_review() {
        if (!this.isAnyNumberOfShiftsOutOfRange()) {
          const proposalId = this.getId(this.proposalFromValue.proposal);
          const url = `/documents/${proposalId}/review/${this.infrastructure}`;
          this.axios.post(url, this.proposalFromValue.proposal.review)
            .then(() => {
              this.$notify({ type: 'success', title: 'Saved successfully!' });
              this.$emit('input', this.proposalFromValue);
              // emit hideModal signal must be handle by parent component
              this.closeModalEmit();
            })
            .catch(() => {
              this.$notify({ type: 'error', title: 'Could not save!' });
            });
        } else {
          this.$notify({ type: 'error', title: 'Shifts out of range' });
        }
      },
    },
  };
</script>

<style scoped>

</style>
